import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/serviceSalesSaga";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";

const CompareDates = () => {
  const dispatch = useDispatch();
  const isActive = useSelector((state) => state.serviceSales.selectedFilters.compare);

  return (
    <ToggleableButton
      isActive={isActive}
      isRadio
      title="service-sales-compare-dates"
      onClick={(data) => dispatch(actionCreators.updateCompareDates(data))}
    />
  );
};

export default CompareDates;
